import {
  createFileRoute,
  Outlet,
  redirect,
  useMatches,
} from "@tanstack/react-router";
import { useAuthStore } from "@/stores/auth-store";
import { AppShell } from "@/components/app-shell";
import { AUTH_ROUTES } from "@/utils/navigation";
import { BreadcrumbNav } from "@/components/breadcrumb-nav";
import { useBreadcrumb } from "@/hooks/use-breadcrumb";

export const Route = createFileRoute("/(protected)")({
  beforeLoad: () => {
    const authStore = useAuthStore.getState();
    if (!authStore.isAuthenticated()) {
      throw redirect({
        to: AUTH_ROUTES.SIGN_IN,
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { breadcrumbs, hasActionButtons, navigate } = useBreadcrumb();
  const spacing = hasActionButtons ? "pr-64" : "";
  const hideMobileChrome = useMatches({
    select: (matches) =>
      matches.some((match) => match.staticData.hideAppChromeOnMobile),
  });

  return (
    <AppShell hideMobileChrome={hideMobileChrome}>
      <main className="relative flex flex-1 flex-col overflow-hidden dark:text-white">
        <div className="hidden md:block md:px-6 md:pt-6">
          <div className={`flex min-h-10 items-center gap-4 ${spacing}`}>
            <BreadcrumbNav
              items={breadcrumbs}
              onNavigate={navigate}
              className="min-w-0 flex-1"
              hasActionButtons={hasActionButtons}
            />
          </div>
        </div>
        <div className="flex flex-1 flex-col overflow-hidden">
          <Outlet />
        </div>
      </main>
    </AppShell>
  );
}
